import { cropName } from '../../common/utils/cropNames.mjs';

const wholeNumber = (value) => Math.max(0, Math.floor(Number(value) || 0));

export const salePricing = (catalog = {}, item = {}) => {
  const quantity = wholeNumber(item.quantity);
  const unitPrice = wholeNumber(catalog[item.cropKey]?.sell_price);

  return {
    quantity,
    unitPrice,
    totalPrice: quantity * unitPrice,
  };
};

export const ownerHarvestQuantity = (cycle = {}) => {
  const baseYield = wholeNumber(cycle.baseYield);
  const effectiveYield = cycle.effectiveYield == null ? baseYield : wholeNumber(cycle.effectiveYield);
  const stolenQuantity = wholeNumber(cycle.stolenQuantity);
  const minimumOwnerQuantity = Math.ceil(effectiveYield * 0.7);

  return Math.max(effectiveYield - stolenQuantity, minimumOwnerQuantity);
};

export const activityMessage = (row = {}) => {
  const crop = cropName(row.cropKey);
  const amount = wholeNumber(row.amount);

  switch (row.type) {
    case 'planted': return `种下了${crop}`;
    case 'harvested': return `收获了 ${amount} 个${crop}`;
    case 'sold': return `出售了 ${amount} 个${crop}`;
    case 'care_water': return `给${crop}浇了水`;
    case 'care_weeds': return `给${crop}除了草`;
    case 'care_pests': return `给${crop}除了虫`;
    case 'steal': return `摘走了 ${amount} 个${crop}`;
    case 'expanded': return `解锁了第 ${amount} 块土地`;
    default: return '农场有新动态';
  }
};
